/**
 * Constantes para o certificado da seguradora
 *
 * @namespace
 * @property {string} NUMERO_APOLICE_PADRAO - Número da apólice padrão.
 */

const certificadosPadraoRcfApp = {
  120: '007.5.01.53.000124 / 008.5.01.000009',
  default: '007.5.01.53.000069 / 008.5.01.000007',
};

const getCertificado = (empresaId) => {
  return (
    certificadosPadraoRcfApp[empresaId] || certificadosPadraoRcfApp.default
  );
};
exports.CERTIFICADO = {
  NUMERO_APOLICE_PADRAO: '007.5.01.53.000124 / 008.5.01.000009',
  getCertificado,
};
